var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('outline-number');
import { breakpoints, theme } from '@shapeable/theme';
export var OutlineNumberSizesBase = {
  default: 30,
  banner: 40,
  bannerLarge: 50,
  cell: 40,
  link: 32
};
export var OutlineNumberSizesTablet = {
  default: 40,
  banner: 50,
  bannerLarge: 60,
  cell: 40,
  link: 32
};
export var OutlineNumberSizesDesktop = {
  default: 50,
  banner: 76,
  bannerLarge: 96,
  cell: 40,
  link: 32
};
export var OutlineNumberFontSizesBase = {
  default: 12,
  banner: 14,
  bannerLarge: 20,
  cell: 14,
  link: 10
};
export var OutlineNumberFontSizesTablet = {
  default: 16,
  banner: 18,
  bannerLarge: 24,
  cell: 14,
  link: 10
};
export var OutlineNumberFontSizesDesktop = {
  default: 16,
  banner: 24,
  bannerLarge: 36,
  cell: 14,
  link: 10
};
export var OutlineNumberDefaultProps = {
  size: 'default',
  color: {
    id: 'default',
    slug: 'default',
    name: 'Default',
    value: '#999'
  },
  showBorder: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n    display: flex;\n    flex-shrink: 0;\n    font-weight: 400;\n    border-radius: 50%;\n    background-color: ", ";\n    align-items: center;\n    justify-content: center;\n    margin-right: ", ";\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    color: ", ";\n    display: flex;\n    flex-shrink: 0;\n    font-weight: 400;\n    border-radius: 50%;\n    background-color: ", ";\n    align-items: center;\n    justify-content: center;\n    margin-right: ", ";\n    ", "\n\n    ", "\n\n    ", "\n  "])), theme.COLOR('strong'), theme.COLOR('light'), theme.UNIT(2), function (_a) {
    var _color = _a._color,
      size = _a.size;
    return _color && _color.value && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", " !important;\n    "], ["\n      color: ", " !important;\n    "])), _color.value);
  }, function (_a) {
    var _color = _a._color,
      showBorder = _a.showBorder;
    return showBorder && _color && _color.value && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border: 1px solid ", ";\n      font-weight: 600;\n      box-sizing: content-box;\n    "], ["\n      border: 1px solid ", ";\n      font-weight: 600;\n      box-sizing: content-box;\n    "])), _color.value);
  }, function (_a) {
    var size = _a.size;
    return size && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      font-size: ", "px;\n      height: ", "px;\n      width: ", "px;\n    "], ["\n      font-size: ", "px;\n      height: ", "px;\n      width: ", "px;\n    "])), OutlineNumberFontSizesBase[size], OutlineNumberSizesBase[size], OutlineNumberSizesBase[size]);
  }),
  tablet: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var size = _a.size;
    return size && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      font-size: ", "px;\n      height: ", "px;\n      width: ", "px;\n    "], ["\n      font-size: ", "px;\n      height: ", "px;\n      width: ", "px;\n    "])), OutlineNumberFontSizesTablet[size], OutlineNumberSizesTablet[size], OutlineNumberSizesTablet[size]);
  }),
  desktop: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var size = _a.size;
    return size && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      font-size: ", "px;\n      height: ", "px;\n      width: ", "px;\n    "], ["\n      font-size: ", "px;\n      height: ", "px;\n      width: ", "px;\n    "])), OutlineNumberFontSizesDesktop[size], OutlineNumberSizesDesktop[size], OutlineNumberSizesDesktop[size]);
  })
});
// -------- Components -------->
var My = {
  Container: styled.b(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var OutlineNumber = function (props) {
  var className = props.className,
    children = props.children,
    color = props.color,
    size = props.size,
    showBorder = props.showBorder;
  return React.createElement(My.Container, {
    showBorder: showBorder,
    _color: color,
    size: size,
    className: cls.name(className)
  }, children);
};
OutlineNumber.defaultProps = OutlineNumberDefaultProps;
OutlineNumber.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;